var _defs, _path, _path2, _rect, _path3, _path4, _path5, _path6, _polyline, _polyline2, _line, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTiff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a1d4fc3e-48f8-45b5-aceb-7d0c2f5cd269",
    "data-name": "\\u5716\\u5C64 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".be17ab5f-2997-4bf5-8b31-ed6f655765e1,.f053a500-f208-4182-8efc-264908438e5b{fill:none;}.af0ea20b-bd9c-4a4b-86a5-31b9ba370560,.be17ab5f-2997-4bf5-8b31-ed6f655765e1{stroke:#8e8e8e;}.af0ea20b-bd9c-4a4b-86a5-31b9ba370560,.be17ab5f-2997-4bf5-8b31-ed6f655765e1,.f053a500-f208-4182-8efc-264908438e5b{stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}.a491f09a-4689-4e9a-b85f-1641ab1f3908,.af0ea20b-bd9c-4a4b-86a5-31b9ba370560{fill:#1495c1;}.e65bfec5-af77-4680-9725-4ce0f7c2623f{fill:#fff;}.f053a500-f208-4182-8efc-264908438e5b{stroke:#645346;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "tiff") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "be17ab5f-2997-4bf5-8b31-ed6f655765e1",
    d: "M22.3,78.2a4.1,4.1,0,0,0,4.1,4.2H67.3a4.2,4.2,0,0,0,4.2-4.2V21.8a4.2,4.2,0,0,0-4.2-4.2H36.7L22.3,32.1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "af0ea20b-bd9c-4a4b-86a5-31b9ba370560",
    d: "M22.3,32.1H32.6A4.1,4.1,0,0,0,36.7,28V17.6Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a491f09a-4689-4e9a-b85f-1641ab1f3908",
    x: 32.8,
    y: 59.5,
    width: 44.9,
    height: 14.99,
    rx: 2.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "e65bfec5-af77-4680-9725-4ce0f7c2623f",
    d: "M45,63.3H41.9V62.2h7.5v1.1H46.3v9H45Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "e65bfec5-af77-4680-9725-4ce0f7c2623f",
    d: "M51.9,62.2V72.3H50.6V62.2Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "e65bfec5-af77-4680-9725-4ce0f7c2623f",
    d: "M54.1,62.2h5.5v1.1H55.4v3.4h3.9v1.1H55.4v4.5H54.1Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "e65bfec5-af77-4680-9725-4ce0f7c2623f",
    d: "M61.4,62.2h5.5v1.1H62.7v3.4h3.9v1.1H62.7v4.5H61.4Z"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "f053a500-f208-4182-8efc-264908438e5b",
    points: "37.1 24.3 63.2 24.3 63.2 53.5 30.6 53.5 30.6 32.7"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "f053a500-f208-4182-8efc-264908438e5b",
    points: "31.1 53.5 42.7 41.9 53.9 53"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "f053a500-f208-4182-8efc-264908438e5b",
    x1: 48,
    y1: 47.1,
    x2: 62.6,
    y2: 32.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "f053a500-f208-4182-8efc-264908438e5b",
    cx: 48,
    cy: 33.8,
    r: 3.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiff);
export default __webpack_public_path__ + "static/media/tiff.87b6d6606a1138b0aa5a0073015f62e8.svg";
export { ForwardRef as ReactComponent };